export default function () {
  const widgetName = 'inducteesTitle';
  const widgetOpts = inducteesTitleOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      const widgetData = data.items[0];
      $(`#${widgetName}`).empty();
      $(`#${widgetName}`).append(`<h1>${widgetData.Title}</h1>`);
    },
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    showDescription: false,
    textOverImage: false,
    buyNowButton: false,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
  });
}
